// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"NoResult_modal-scroll__DUTxZ","none-result":"NoResult_none-result__8wxm2","padding":"NoResult_padding__yDeph"};